import formatPrice from 'utils/formatPrice';

const getOrderLineTotalCharge = ({ orderLine, value, index, part, caloricUnitsSupport }) => {
  if (value !== null && value !== undefined) {
    return value;
  }
  if (index !== undefined) {
    const indexOrderLine = orderLine ? orderLine[index] : null;
    if (indexOrderLine) {
      const units = caloricUnitsSupport && indexOrderLine['Calories Per Unit']
          ? Math.ceil(indexOrderLine.Units * indexOrderLine['Calories Per Unit'] / 100) : indexOrderLine.Units;
      const totalCharge = indexOrderLine && indexOrderLine.Charge
        ? formatPrice(Number(indexOrderLine.Charge.replace('$', '').replace(',', ''))
          * Number(units)).replace('$', '').replace(',', '') : null;
      if (totalCharge) {
        switch (part) {
          case 'dollars':
            return Number(totalCharge.split('.')[0]);
          case 'cents':
            return totalCharge.split('.')[1];
          default:
            return totalCharge;
        }
      }
      return null;
    }
    return null;
  }
  const totalCharge = orderLine
    ? orderLine.map((item) => {
      const units = caloricUnitsSupport && item['Calories Per Unit']
        ? Math.ceil(item.Units * item['Calories Per Unit'] / 100) : item.Units;
      return item.Charge ? formatPrice(Number(item.Charge.replace('$', '').replace(',', ''))
      * Number(units)).replace('$', '').replace(',', '') : '0';
    }).join(', ')
    : null;
  if (totalCharge) {
    switch (part) {
      case 'dollars':
        return Number(totalCharge.split('.')[0]);
      case 'cents':
        return totalCharge.split('.')[1];
      default:
        return totalCharge;
    }
  }
  return null;
};

export default getOrderLineTotalCharge;



// WEBPACK FOOTER //
// ./src/utils/print/getOrderLineTotalCharge.js